<dgx-modal [canCancel]="false" [isFooterless]="true">
  <ng-container class="modal-header">
    {{ headerText }}
  </ng-container>

  <ng-container class="modal-body">
    <div class="guts-p-full-2">
      <span class="par">{{ bio }}</span>
    </div>
  </ng-container>
</dgx-modal>
